<div
    class="product-search"
    role="combobox"
    aria-haspopup="listbox"
    aria-owns="product-search-listbox"
    [attr.aria-expanded]="showPanel()"
>
    <ion-searchbar
        #searchbar
        class="searchbar product-searchbar"
        [class.expanded]="showPanel()"
        type="search"
        inputmode="search"
        autocomplete="off"
        [debounce]="0"
        [value]="query()"
        [placeholder]="'keywordsearch' | translate"
        [attr.aria-label]="'productSearch.label' | translate"
        aria-controls="product-search-listbox"
        (ionInput)="onIonInput($event)"
        (ionClear)="clearQuery()"
        (ionFocus)="onFocus()"
        (click)="onSearchbarClick()"
        (keydown)="onKeydown($event)"
    ></ion-searchbar>
    <button
        type="button"
        class="searchbar-submit-button"
        [attr.aria-label]="'productSearch.label' | translate"
        (click)="onSearchButtonClick()"
    >
        <ion-icon name="search-outline" aria-hidden="true"></ion-icon>
    </button>

    @if (showPanel()) {
        <ion-list
            class="panel"
            id="product-search-listbox"
            lines="full"
            role="listbox"
            [attr.aria-label]="'productSearch.label' | translate"
        >
            @if (state().status === "loading") {
                <ion-item lines="none" class="panel-state loading-state">
                    <ion-spinner name="crescent"></ion-spinner>
                    <ion-label>{{ "productSearch.status.loading" | translate }}</ion-label>
                </ion-item>
            }

            @if (state().status === "error") {
                <ion-item lines="none" class="panel-state">
                    <ion-label>{{ "productSearch.error" | translate }}</ion-label>
                </ion-item>
            }

            @if (state().status === "empty") {
                <ion-item lines="none" class="panel-state">
                    <ion-label>
                        <h3>{{ "productSearch.empty" | translate }}</h3>
                        <p>{{ "productSearch.emptyHint" | translate }}</p>
                    </ion-label>
                </ion-item>
            }

            @if (state().status === "results") {
                @if (state().results.machines.length) {
                    <ion-list-header>
                        <ion-label>{{ "productSearch.groups.machines" | translate }}</ion-label>
                    </ion-list-header>
                    @for (item of state().results.machines; track item.id; let i = $index) {
                        <app-product-search-result-item
                            [result]="item"
                            [active]="activeIndex() === i"
                            (selected)="onResultSelected($event)"
                        ></app-product-search-result-item>
                    }
                }
                @if (state().results.variants.length) {
                    <ion-list-header>
                        <ion-label>{{ "productSearch.groups.variants" | translate }}</ion-label>
                    </ion-list-header>
                    @for (item of state().results.variants; track item.id; let i = $index) {
                        <app-product-search-result-item
                            [result]="item"
                            [active]="activeIndex() === state().results.machines.length + i"
                            (selected)="onResultSelected($event)"
                        ></app-product-search-result-item>
                    }
                }
            }

            @if (state().status === "results" || state().status === "empty") {
                <ion-item
                    button
                    detail="false"
                    lines="none"
                    class="show-all"
                    [class.active]="showAllActive()"
                    id="product-search-option-show-all"
                    role="option"
                    [attr.aria-selected]="showAllActive()"
                    (click)="showAllResults()"
                >
                    <ion-icon slot="start" name="search-outline" aria-hidden="true"></ion-icon>
                    <ion-label>{{
                        "productSearch.showAll"
                            | translate
                                : { count: state().results.totalCount, query: query().trim() }
                    }}</ion-label>
                </ion-item>
            }
        </ion-list>
    }
</div>
